import { ErrorBoundary } from 'react-error-boundary'

const ErrorFallback = () => {
  return (
    <div className="f">
      <h2 className="text-lg font-semibold">Ooops, something went wrong :( </h2>
      <button>refresh</button>
    </div>
  )
}

export const AppProvider = ({ children }: { children: React.ReactNode }) => {
  return <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>
}
